/** When your routing table is too long, you can split it into small modules**/
/* Layout */
import Layout from '@/layout'

/* Router Modules */
const brandRouter = {
  path: '/brand',
  component: Layout,
  name: 'brand',
  redirect: '/brand',
  meta: {
    title: '品牌形象'
  },
  children: [
    {
      path: '/brand',
      component: () => import('@/views/brand/index'),
      name: 'Brand',
      meta: { title: '品牌形象', affix: true, projectId: 2 }
    },
    {
      path: '/brand/detail',
      component: () => import('@/views/brand/detail'),
      name: 'BrandDetail',
      hidden: true,
      meta: { title: '方案详情', affix: true, projectId: 2, guidePath: true, jumpPath: '/brand' }
    }
  ]
}

export default brandRouter
